module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/05-4cbc8fac595178ece049e0d055e150b0.jpg";